<template>
    <div>
        <div v-if="loaded && cart.products.length" class="row">
            <div class="col-md-9 pt-4 pt-md-0">
                <div class="d-flex mb-4">
                    <div v-for="(stepLabel, stepIndex) in steps"
                    :key="stepLabel"
                    class="col h5 mb-2 fw-bold text-start"
                    :class="{'cursor-pointer text-primary': steps.findIndex((stepLabel) => stepLabel == step) >= stepIndex}"
                    @click='steps.findIndex((stepLabel) => stepLabel == step) > stepIndex ? changeStep(stepLabel) : null'
                    :disabled="/*formPayment.busy || */steps.findIndex((stepLabel) => stepLabel == step) < stepIndex"
                    >
                        {{stepIndex+1}}. {{ t.checkout[stepLabel] }}
                    </div>
                </div>
                <transition-group name="fade" tag="div" >
                    <div v-if="step == 'personal_details'" key="personal_details">
                        <personal-details-component
                        v-bind="this.$data"
                        v-on:goToNextStep="goToNextStep"
                        v-on:updateUser="updateUser"
                        ></personal-details-component>
                    </div>
                    <div v-else-if="step == 'shipping_details'" key="shipping_details">
                        <shipping-details-component
                        v-bind="this.$data"
                        v-on:goToNextStep="goToNextStep"
                        v-on:back="back"
                        ></shipping-details-component>
                    </div>
                    <div v-else-if="step == 'delivery_date_selection'" key="delivery_date_selection">
                        <delivery-date-selection-component
                        v-bind="this.$data"
                        v-on:goToNextStep="goToNextStep"
                        v-on:back="back"
                        ></delivery-date-selection-component>
                    </div>
                    <div v-else-if="step == 'payment'" key="payment">
                        <payment-component
                        v-bind="this.$data"
                        v-on:goToNextStep="goToNextStep"
                        v-on:back="back"
                        ></payment-component>
                    </div>
                </transition-group>
            </div>
            <div class="col-md pt-5 pt-md-0">
                <div class="mb-2 pt-5">
                    <div class="row align-items-center" :class="{'mt-2': index}" v-for="(product, index) in cart.products" :key="product.id">
                        <div class="col-4">
                            <a :href="product.url">
                                <img :src="product.thumbnail" alt="" class="img-fluid">
                            </a>
                        </div>
                        <div class="col-6 small">
                            <a :href="product.url">
                                <span class="fw-bold">{{ product.name }}</span>
                                <div v-if="product.product_variation_attributes">
                                    <div v-for="(prod_var_attr, index) in product.product_variation_attributes" :key="index"><b>{{prod_var_attr.attribute.name}}</b>: {{prod_var_attr.value.name}}</div>
                                </div>
                            </a>
                            <div v-if="product.is_gift">
                                {{ t.cart.gift_card}}: <i>"{{ product.gift_card ? product.gift_card : t.gift_card_not_specified }}"</i>
                            </div>
                            <div class="text-muted">{{ amountWithCurrency(product.total) }}</div>
                        </div>
                        <div class="col">x{{ product.qty }}</div>
                    </div>
                </div>
                <a :href="url('cart')" class="btn btn-light w-100 mb-3">{{ t.checkout.edit_cart}}</a>
                <cart-summary-component></cart-summary-component>
            </div>
        </div>
    </div>
</template>

<script>
import store from "../CartStore";
// import PersonalDetailsComponent from './checkout/PersonalDetailsComponent.vue';
// import ShippingDetailsComponent from './checkout/ShippingDetailsComponent.vue';
// import DeliveryDateSelectionComponent from './checkout/DeliveryDateSelectionComponent.vue';
// import PaymentComponent from './checkout/PaymentComponent.vue';
export default {
    store: store,
    components: {
        // PersonalDetailsComponent,
        // ShippingDetailsComponent,
        // DeliveryDateSelectionComponent,
        // PaymentComponent
    },
    data() {
        return {
            config: window.config,
            t: window.t,
            currency: window.currency,
            step: window.step ? window.step : 'personal_details',
            steps: [],
            user: user,
        };
    },
    mounted() {
        this.$store.dispatch("getCart");
        this.steps = [
            'personal_details',
        ]
        if (this.config.modules.delivery_date_selection) {
            this.steps.push('delivery_date_selection')
        }
        this.steps.push('shipping_details')
        this.steps.push('payment')
    },
    computed: {
        ...Vuex.mapGetters(['loaded', 'cart']),
    },
    methods: {
        updateUser(user) {
            this.user = user
        },
        goToNextStep() {
            this.step = this.steps[this.steps.findIndex(stepLabel => stepLabel == this.step)+1]
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        back() {
            this.step = this.steps[this.steps.findIndex((step) => this.step == step)-1]
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        changeStep(newStep) {
            this.step = newStep
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        // flushCart(){
        //     axios.post('/ajax/cart/flush');
        // },
        ...Vuex.mapActions(["applyVoucher", "deleteVoucher"]),
    },
};
</script>
